import { useState } from 'react';


const SuperscriptGenerators = () => {
  const [inputValue, setInputValue] = useState('');
  const [result, setResult] = useState('');


  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    const superscriptText = e.target.value
      .split('')
      .map((char) => {
        const superscriptMap = {
          '0': '⁰', '1': '¹', '2': '²', '3': '³', '4': '⁴', '5': '⁵',
          '6': '⁶', '7': '⁷', '8': '⁸', '9': '⁹', 'a': 'ᵃ', 'b': 'ᵇ',
          'c': 'ᶜ', 'd': 'ᵈ', 'e': 'ᵉ', 'f': 'ᶠ', 'g': 'ᵍ', 'h': 'ʰ',
          'i': 'ⁱ', 'j': 'ʲ', 'k': 'ᵏ', 'l': 'ˡ', 'm': 'ᵐ', 'n': 'ⁿ',
          'o': 'ᵒ', 'p': 'ᵖ', 'q': 'ᑫ', 'r': 'ʳ', 's': 'ˢ', 't': 'ᵗ',
          'u': 'ᵘ', 'v': 'ᵛ', 'w': 'ʷ', 'x': 'ˣ', 'y': 'ʸ', 'z': 'ᶻ',
          'A': 'ᴬ', 'B': 'ᴮ', 'C': 'ᶜ', 'D': 'ᴰ', 'E': 'ᴱ', 'F': 'ᶠ',
          'G': 'ᴳ', 'H': 'ᴴ', 'I': 'ᴵ', 'J': 'ᴶ', 'K': 'ᴷ', 'L': 'ᴸ',
          'M': 'ᴹ', 'N': 'ᴺ', 'O': 'ᴼ', 'P': 'ᴾ', 'Q': 'ᑫ', 'R': 'ᴿ',
          'S': 'ˢ', 'T': 'ᵀ', 'U': 'ᵁ', 'V': 'ᵛ', 'W': 'ᵂ', 'X': 'ˣ',
          'Y': 'ʸ', 'Z': 'ᶻ',
        };
        return superscriptMap[char] || char;
      })
      .join('');
    setResult(superscriptText);
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Script'); // State for button label

  const handleCopyClick = () => {
    navigator.clipboard.writeText(result);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Script'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };


    // Clear input fields
    const clearFields = () => {
      setInputValue('');
      setResult('');
    };


    // Function to calculate text statistics
    const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(inputValue);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
  
    <div className="card-body">
    
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        style={{ height: '5rem' }}
        className="form-control mb-3"
        placeholder="Enter text to convert to superscript"
      />
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span className="text-muted">Result:</span>
        
      </div>
        <input
        type="text"
        value={result}
        onChange={handleInputChange}
        style={{ height: '5rem' }}
        className="form-control mb-3"
        placeholder="Enter text to convert to superscript"
      />
        <button
        className="btn btn-primary mt-3"
          onClick={handleCopyClick}
        >
         {copyButtonLabel}
         </button>
         <button className="btn btn-danger mt-3" onClick={clearFields}>
            Clear
          </button>
     
    </div>
    <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
 
</div>

  );
};

export default SuperscriptGenerators;
